import React, { useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';

import '../scss/RegBreadcrumb.scss';

const RegBreadcrumb = ({ page }) => {

    const pages = [
        'Start',
        'Select',
        'Confirm',
        'Pay',
        'Complete'
    ];

    return (
        <Breadcrumb>
            {
                pages.map((val, i) => (
                    <Breadcrumb.Item active={i==page? true:false} key={i}>{val}</Breadcrumb.Item>
                ))
            }
        </Breadcrumb>
    );
}

export default RegBreadcrumb;